import React, { memo, useCallback } from 'react'
import { useWatch } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import Box from 'transfix-ui/core/Box'
import { Maybe } from 'types/graphqlTypes'
import { useCreateShipmentFormContext } from '../../context'
import useCreateShipment from '../../hooks/useCreateShipment'
import { TCreateShipmentSchema } from '../../schema'
import EquipmentDetailsFormSection from '../EquipmentDetailsFormSection'
import ShipmentFormSection from '../ShipmentFormSection'

export interface ICreateShipmentFormProps {}

const CreateShipmentForm = memo<ICreateShipmentFormProps>(() => {
  const history = useHistory()

  const { createShipment, errors, loading } = useCreateShipment()

  const { control, handleSubmit } = useCreateShipmentFormContext()

  const shipperApplication: Maybe<TCreateShipmentSchema['shipperApplication']> = useWatch({
    control,
    name: 'shipperApplication',
  })
  const { id: shipperApplicationId } = shipperApplication || {}

  const shipmentCreate = useCallback(
    async (formValues: TCreateShipmentSchema) => {
      const { shipmentId } = await createShipment(formValues)

      if (shipmentId) {
        history.push(`shipment-details/${shipmentId}`)
      }
    },
    [createShipment, history]
  )

  const handleCreate = handleSubmit(shipmentCreate)

  return (
    <div>
      <div data-test='form-errors'>
        {errors.map(({ key, message }) => (
          <InlineMessage
            key={key}
            message={message}
            dataTest={`form-error-${key}`}
            type={INLINE_MESSAGE_VARIANTS.ALERT}
            fullWidth
          />
        ))}
      </div>
      <Box mb={4}>
        <EquipmentDetailsFormSection />
      </Box>
      {shipperApplicationId && <ShipmentFormSection shipperApplicationId={shipperApplicationId} />}
      <Box display='flex' justifyContent='flex-end'>
        <Button
          type='submit'
          data-test='create-shipment-submit'
          disabled={loading}
          onClick={handleCreate}>
          Submit Shipment
        </Button>
      </Box>
    </div>
  )
})

export default CreateShipmentForm
